import { Box, Stack, Text } from "@chakra-ui/react";
import { SectionProps } from "../../sections/sectionsComponents";
import { EventDetailMarketingLinksSection } from "@common/interfaces/KYDEvent";
import { MarketingTable } from "./MarketingTable";

const MarketingSection = ({
  data,
}: SectionProps<EventDetailMarketingLinksSection["data"]>) => {
  return (
    <Stack>
      <Box py={4} overflowX={"scroll"}>
        {data ? (
          <MarketingTable
            data={{ slug_id: data.organization?.slug_id, id: data.id }}
          />
        ) : null}
      </Box>
    </Stack>
  );
};

export default MarketingSection;
